import { PassCode } from 'components/PassCode'

import { useDispatch, useSelector } from 'react-redux'
import { authSlice } from '../../../authSlice'
import { usePutApiV1AccountsResendEmailByHashMutation } from '@wellesley/openapi'
import { useSignUpHash } from '../hooks/useSignUpHash'
import { useSendPassCode } from './hooks/useSendPassCode'
import { Button, ButtonLoader } from '@wellesley/ui'
import { useState } from 'react'
import { SignUpStages } from '../SignUpStages'
import { getErrorMsg } from '@wellesley/error-kit'

export const SignUpPassCode = () => {
  const [passCode, setPassCode] = useState<number>()
  const [isCodeFulfilled, setIsCodeFulfilled] = useState(false)
  const dispatch = useDispatch()
  const signupFields = useSelector(authSlice.selectors.selectSignupFields)

  const hash = useSignUpHash()
  const { send, isError, error, isLoading } = useSendPassCode()

  const [resendEmail] = usePutApiV1AccountsResendEmailByHashMutation()

  return (
    <div className="flex flex-col items-center gap-m">
      <SignUpStages position={3} />
      <PassCode
        errorMsg={getErrorMsg(error)}
        email={signupFields?.email}
        isError={isError}
        onResend={() =>
          hash &&
          void resendEmail({
            hash,
          })
        }
        onSubmit={setPassCode}
        onFullFilled={setIsCodeFulfilled}
      />

      <div className="flex w-[450px] justify-between py-s">
        <Button
          variant="secondary"
          size="m"
          onClick={() => dispatch(authSlice.actions.setSignupStep('signup'))}
        >
          Back
        </Button>
        <ButtonLoader
          isLoading={isLoading}
          disabled={!isCodeFulfilled}
          variant="primary"
          size="m"
          onClick={() => passCode && send(passCode)}
        >
          Confirm
        </ButtonLoader>
      </div>
    </div>
  )
}
